import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { MonitoringHeaderChat } from './components/monitoringHeaderChat';

import {
  Container,
  Row,
  Card,
  Nav,
  NavItem,
  TabContent,
  TabPane
} from 'reactstrap';

// eslint-disable-next-line
import { MonitoringDetails } from './components/MonitoringDetails/MonitoringDetails';
import { MonitoringSynthetic } from './components/MonitoringSynthetic';
import useChannels from 'hooks/useChannels';
import { parseUnknownToSelectableOption } from 'utils/fuctions/parseUnknownToSelectableOption';
import { TabNavigationButton } from 'components/TabNavigationButton';
import { useSocketConversationChatTs } from 'hooks/useSocketConversationChatTs';
import useGetTags from 'hooks/useGetTags';
import { useChatMonitoring } from './hooks/useChatMonitoring';
import { useMakeConversationCounters } from './hooks/useMakeConversationCounters';
import { useQueueContentChatContext } from '../../../../hooks/useQueueContentChat';

const MonitoringConversation = () => {
  const [queues, setQueues] = useState([]);
  const {
    monitoringData,
    getMonitoringData,
    isLoadingMonitoringData,
    setIsLoadingMonitoringData,
    setMonitoringData
  } = useChatMonitoring();

  const { getQueuesChat } = useQueueContentChatContext();
  const { makeConversationCountersDTO } = useMakeConversationCounters();

  /** @type {unknown[]} */
  const channels = useChannels({
    names: [
      'facebook',
      'watson',
      'whatsapp',
      'telegram',
      'instagram',
      'sms',
      'webchat',
      'flex4u'
    ]
  });
  const channelOptions = channels.map((channel) =>
    parseUnknownToSelectableOption(channel, 'nome_canal', 'id')
  );

  /**
   * @type {["synthetic" | "detailed", React.Dispatch<React.SetStateAction<"synthetic" | "detailed">>]}
   */
  const [activeTab, setActiveTab] = useState(
    localStorage.getItem('activeTabMonitoring') || 'detailed'
  );

  const changeActiveTab = (tab) => {
    setActiveTab(tab);
    localStorage.setItem('activeTabMonitoring', tab);
  };

  const systemConfiguration = useSelector((state) => state.systemConfiguration);

  const { emitEventGetAllDataMonitoringQueueChat } =
    useSocketConversationChatTs();

  const { tags } = useGetTags();
  const tagOptions =
    tags?.map?.((tag) => parseUnknownToSelectableOption(tag, 'name', 'id')) ??
    [];

  /** @type {[boolean, React.Dispatch<React.SetStateAction<boolean>>]} - Determina se deve ou não ser criado um protocolo ao encerrar a conversa */

  useEffect(() => {
    emitEventGetAllDataMonitoringQueueChat();
    const showIndividualQueue = true;
    getQueuesChat(showIndividualQueue).then((queues) => {
      setQueues(queues);
    });
  }, []);

  return (
    <>
      <MonitoringHeaderChat
        dataToShow={makeConversationCountersDTO({ ...monitoringData?.data })}
      />
      <Container className="mt--6" fluid style={{ padding: '1rem' }}>
        <Row>
          <div className="col">
            <div className="card-wrapper">
              <Card
                style={{
                  borderRadius: systemConfiguration.border_radius,
                  padding: '1rem',
                  position: 'relative'
                }}
              >
                <Nav
                  justified
                  pills
                  style={{
                    position: 'absolute',
                    top: '1rem',
                    zIndex: 2
                  }}
                >
                  <NavItem>
                    <TabNavigationButton
                      isActive={activeTab === 'detailed'}
                      onClick={() => {
                        changeActiveTab('detailed');
                      }}
                      title="Detalhado"
                    />
                  </NavItem>
                  <NavItem>
                    <TabNavigationButton
                      isActive={activeTab === 'synthetic'}
                      onClick={() => {
                        changeActiveTab('synthetic');
                      }}
                      title="Sintético"
                    />
                  </NavItem>
                </Nav>
                <TabContent activeTab={activeTab}>
                  <TabPane tabId="detailed">
                    <MonitoringDetails
                      queues={queues}
                      canalOptions={channelOptions}
                      monitoringData={monitoringData}
                      getMonitoringData={getMonitoringData}
                      isLoadingMonitoringData={isLoadingMonitoringData}
                      setIsLoadingMonitoringData={setIsLoadingMonitoringData}
                      setMonitoringData={setMonitoringData}
                    />
                  </TabPane>
                  <TabPane tabId="synthetic">
                    <MonitoringSynthetic
                      channelOptions={channelOptions}
                      contactTagOptions={tagOptions}
                      queueOptions={queues}
                    />
                  </TabPane>
                </TabContent>
              </Card>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default MonitoringConversation;
